<a [airLink]="item.url" [userEventSource]="userEventSource" [userEventLabel]="title" class="results-item">
  <span class="results-item__title">
    <strong class="text-primary">{{ title }}</strong>
    <span *ngIf="parent" class="results-item__parent">
      <span>{{ "general.search.in" | translate }}</span>
      <strong>{{ parent }}</strong>
    </span>
  </span>
  <span class="icon icon-ui-arrow--right--sm results-item__icon"></span>
  <span class="results-item__description">{{ description }}</span>
</a>
